import {createApp} from 'vue'
import LoginOverlay from './LoginOverlay'

const el = '[data-content=LoginOverlay]'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((LoginOverlayDOM)=>{
            const loginUrl = LoginOverlayDOM.dataset.loginUrl
            const createProfileUrl = LoginOverlayDOM.dataset.createProfileUrl

            Store.commit('main/set_page_overlay_content_data',{ loginUrl, createProfileUrl })
        })
    }
}